const numericLiteral = (value, fallback) => {
    const number = Number(value);
    return Number.isFinite(number) ? String(number) : String(fallback);
};

const createShadow = (id, parent, opcode, fieldName, value) => ({
    id,
    opcode,
    next: null,
    parent,
    inputs: {},
    fields: {[fieldName]: {name: fieldName, value: String(value)}},
    shadow: true,
    topLevel: false,
    mutation: null
});

const addInputShadow = (block, blocks, name, shadowOpcode, fieldName, value) => {
    const shadowId = `${block.id}-${name.toLowerCase()}`;
    block.inputs[name] = {name, block: shadowId, shadow: shadowId};
    blocks.push(createShadow(shadowId, block.id, shadowOpcode, fieldName, value));
};

const createBlock = (definition, id, next, parent, blocks) => {
    const block = {
        id,
        opcode: definition.opcode,
        next,
        parent,
        inputs: {},
        fields: {},
        shadow: false,
        topLevel: false,
        mutation: null
    };
    if (definition.opcode === 'looks_sayforsecs') {
        addInputShadow(block, blocks, 'MESSAGE', 'text', 'TEXT', String(definition.text || ''));
        addInputShadow(block, blocks, 'SECS', 'math_number', 'NUM', numericLiteral(definition.seconds, 2));
    } else if (definition.opcode === 'motion_movesteps') {
        addInputShadow(block, blocks, 'STEPS', 'math_number', 'NUM', numericLiteral(definition.steps, 10));
    } else if (definition.opcode === 'motion_turnright' || definition.opcode === 'motion_turnleft') {
        addInputShadow(block, blocks, 'DEGREES', 'math_number', 'NUM', numericLiteral(definition.degrees, 15));
    } else if (definition.opcode === 'control_wait') {
        addInputShadow(block, blocks, 'DURATION', 'math_number', 'NUM', numericLiteral(definition.seconds, 1));
    } else if (definition.opcode === 'sound_playuntildone' || definition.opcode === 'sound_play') {
        addInputShadow(block, blocks, 'SOUND_MENU', 'sound_sounds_menu', 'SOUND_MENU', String(definition.sound || ''));
    }
    return block;
};

export const createGeneratedBlockStack = (definitions, prefix) => {
    const startId = `${prefix}-start`;
    const ids = definitions.map((definition, index) => `${prefix}-${index}`);
    const blocks = [];
    blocks.push({
        id: startId,
        opcode: 'event_whenflagclicked',
        next: ids[0] || null,
        parent: null,
        inputs: {},
        fields: {},
        shadow: false,
        topLevel: true,
        mutation: null,
        x: 40,
        y: 40
    });
    definitions.forEach((definition, index) => {
        const parent = index ? ids[index - 1] : startId;
        const generated = createBlock(definition, ids[index], ids[index + 1] || null, parent, blocks);
        blocks.push(generated);
    });
    return {blocks, startId};
};
